module.exports = "../fonts/telegram_enter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telegram_enter.svg
// module id = 97
// module chunks = 0